<template>
  <div v-if="mounted">
    <teleport to="#overlay-main">
      <div
      v-if="show"
      @click.stop="stopCloseHandler"
      :class="[
          {
            'modal': true,
            'modal--show': show,
          },
          modalData.customClassName,
        ]">
        <div class="modal__card">
          <!-- standard icon -->
          <div 
            v-if="modalData.icon"
            class="modal__icon" 
            :class="modalData.iconClassName"
          >
            <div 
              class="modal__icon-content"
              :style="`mask: url(${modalData.icon}) no-repeat center;mask-size: contain;`"
            ></div>
          </div>
          <!-- custom icon -->
          <!-- <div class="modal__icon" v-if="modalData.customIconTemplate">
            <div v-html="modalData.customIconTemplate" class="modal__icon-custom-template"></div>
          </div> -->
          <div class="modal__content">
            <div class="modal__title">{{modalData.title}}</div>
            <div class="modal__update-time"
                v-if="!!modalLastUpdate">
              <translated-text-component translation="modal_update_datetime" />
              {{ modalLastUpdate }}
            </div>
            <div v-else>
              <div
                class="modal__update-time"
                v-if="!!modalCreateTime"
              >
                <translated-text-component translation="modal_creation_time" />
                {{ modalCreateTime }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="!!modalData.templateName"
          class="modal__custom-templates"
        >
          <component :is="activeTemplate" :template-data="modalData"></component>
        </div>
        <div
          v-else
          class="" v-html="modalData.content"
        />
        <div class="modal__buttons"
            v-if="modalData.hideModalBtn !== true"
            :class="directionGoogleLink === 'user denied geolocation'
            ? '' : ''">
          <div @click="navigate('waze')"
              class="modal__button"
              v-if="directionWazeLink !== ''"
              v-ripple>
            <svg xmlns="http://www.w3.org/2000/svg"
                width="19.829" height="19.389"
                viewBox="0 0 19.829 19.389">
              <defs></defs>
              <path class="a"
                    d="M-200.118,578.466l-17.937,8.231a.942.942,0,0,0-.542.984.94.94,0,0,0,
                    .781.808l7.614,1.276.868,7.169a.95.95,0,0,0,.774.817.914.914,0,0,0,.165.015.949
                    .949,0,0,0,.847-.526l8.673-17.5a.949.949,0,0,0-.169-1.08A.943.943,0,0,0-200.118,
                    578.466Z"
                    transform="translate(218.606 -578.378)"/>
            </svg>
            WAZE
          </div>
          <div @click="navigate('google')"
              class="modal__button"
              v-if="directionGoogleLink !== ''"
              v-ripple>
            <svg xmlns="http://www.w3.org/2000/svg"
                width="19.829" height="19.389"
                viewBox="0 0 19.829 19.389">
              <defs></defs>
              <path class="a"
                    d="M-200.118,578.466l-17.937,8.231a.942.942,0,0,0-.542.984.94.94,0,0,0,
                    .781.808l7.614,1.276.868,7.169a.95.95,0,0,0,.774.817.914.914,0,0,0,.165.015.949
                    .949,0,0,0,.847-.526l8.673-17.5a.949.949,0,0,0-.169-1.08A.943.943,0,0,0-200.118,
                    578.466Z"
                    transform="translate(218.606 -578.378)"/>
            </svg>
            Google
          </div>
          <!-- <div v-if="directionGoogleLink === 'user denied geolocation'"
              class="modal__button--geolocation-alert">
            Aby nawigować udostępnij swoja lokalizację
          </div> -->
        </div>
        <v-btn 
          @click="closeOverlay()"
          class="modal__close"
          icon="mdi mdi-close"
          variant="text"
         >
        </v-btn>
        <div class="modal__footer">
          <div class="modal__footer-logo">
            <img class="modal__footer-logo-image" :src="require('@/assets/img/its-chorzow-male-logo.png')" alt="Logo">
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script lang="ts">
import {
  computed, defineComponent, Ref, onMounted,
  ref,
} from 'vue';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import NavigationService from '@/services/NavigationService';
import { Marker } from 'leaflet';
import TemplateModalParking from '@/components/modal_templates/TemplateModalParking.vue';
import TemplateModalParkingGroup from '@/components/modal_templates/TemplateModalParkingGroup.vue';
import TemplateModalWeatherStation from '@/components/modal_templates/TemplateModalWeatherStation.vue';
import TemplateModalParkingSpot from '@/components/modal_templates/TemplateModalParkingSpot.vue';
import TemplateModalParkingZone from '@/components/modal_templates/TemplateModalParkingZone.vue';
import TemplateModalEvent from '@/components/modal_templates/TemplateModalEvent.vue';
import TemplateModalVmsBoard from '@/components/modal_templates/TemplateModalVmsBoard.vue';
import TemplateModalCamera from '@/components/modal_templates/TemplateModalCamera.vue';
import TemplateModalPoi from '@/components/modal_templates/TemplateModalPoi.vue';
import TemplateModalTrafficLine from '@/components/modal_templates/TemplateModalTrafficLine.vue';
import TemplateModalOpenWeather from '@/components/modal_templates/TemplateModalOpenWeather.vue';
import TemplateModalBikeStation from '@/components/modal_templates/TemplateModalBikeStation.vue';
import TemplateModalRadarBoard from '@/components/modal_templates/TemplateModalRadarBoard.vue';
import RedrawService from '@/services/RedrawService';
import MapService from '@/services/MapService';
import TemplateModalParkingMeter from '../modal_templates/TemplateModalParkingMeter.vue';
import TemplateModalParkingBoard from '../modal_templates/TemplateModalParkingBoard.vue';

const Modal: object = defineComponent({
  components: {
    TemplateModalParking,
    TemplateModalParkingGroup,
    TemplateModalWeatherStation,
    TemplateModalParkingSpot,
    TemplateModalParkingZone,
    TemplateModalParkingMeter,
    TemplateModalEvent,
    TemplateModalVmsBoard,
    TemplateModalCamera,
    TemplateModalPoi,
    TemplateModalTrafficLine,
    TemplateModalOpenWeather,
    TemplateModalBikeStation,
    TemplateModalParkingBoard,
    TemplateModalRadarBoard,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      name: 'show',
    },
  },
  name: 'Modal',
  setup() {
    /*eslint-disable */
    let activeTemplate: Ref<string | undefined> = computed(() => store.state.modal.data.templateName);
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);

    const mounted = ref(false);
    onMounted(() => {
      mounted.value = true;
    });

    const closeOverlay = () => {
      store.commit('closeModal');
      // added for restart traffic polylines to init values
      if (activeTemplate.value === 'TemplateModalTrafficLine') {
        const redrawService: RedrawService = new RedrawService(new MapService(store.state.leafletMapInstance));
        redrawService.redrawOnlyTrafficLines();
      }
    };
    const stopCloseHandler = (e: any) => {
      e.stopPropagation();
    };

    const modalData: Ref<IModalData> = computed(() => store.state.modal.data);

    const modalLastUpdate: Ref<string | undefined> = computed(
      () => {
        if (!!modalData.value.lastUpdate
          && modalData.value.lastUpdate !== 'b/d'
        ) {
          const fullDate = new Date(modalData.value.lastUpdate);
          const date = {
            year: fullDate.getFullYear(),
            month: ("0" + (fullDate.getMonth() + 1)).slice(-2),
            day: ("0" + fullDate.getDate()).slice(-2),
          };
          const time = fullDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

          return `${date.year}-${date.month}-${date.day}  ${time}`;
        }
      }
    );

    const modalCreateTime: Ref<string | undefined> = computed(
      () => {
        if (!!modalData.value.createTime
          && modalData.value.createTime !== 'b/d'
        ) {
          const fullDate = new Date(modalData.value.createTime);
          const date = {
            year: fullDate.getFullYear(),
            month: ("0" + (fullDate.getMonth() + 1)).slice(-2),
            day: ("0" + fullDate.getDate()).slice(-2),
          };
          const time = fullDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

          return `${date.year}-${date.month}-${date.day}  ${time}`;
        }
      }
    );

    const directionGoogleLink: Ref<string> = computed(
      () => {
        if (!modalData.value.navigationPoint) {
          return '';
        }

        if (!store.state.userPositionMarker.getLatLng()) {
          return 'user denied geolocation';
        }

        const navigationPoint = modalData.value.navigationPoint as Marker;
        return NavigationService.generateNavigationLink(
          store.state.userPositionMarker.getLatLng(),
          navigationPoint.getLatLng(),
        );
      },
    );

    const directionWazeLink: Ref<string> = computed(
      () => {
        if (!modalData.value.navigationPoint) {
          return '';
        }

        if (!store.state.userPositionMarker.getLatLng()) {
          return 'user denied geolocation';
        }

        const navigationPoint = modalData.value.navigationPoint as Marker;
        return NavigationService.generateWazeNavigationLink(
          store.state.userPositionMarker.getLatLng(),
          navigationPoint.getLatLng(),
        );
      },
    );

    const navigate = (type: string): void => {
      if (directionGoogleLink.value !== 'user denied geolocation') {
        if (type === 'waze') {
          window.open(directionWazeLink.value);
          } else  {
          window.open(directionGoogleLink.value);
        }
      } else {
        alert('Aby nawigować udostępnij swoja lokalizację');
      }
    };

    onMounted(() => {
      const overlay = document.querySelector('.overlay');

      if (overlay) {
        overlay.addEventListener('click', () => {
          if (overlay.classList.contains('overlay--show')) {
            closeOverlay();
          }
        });
      }
      window.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          closeOverlay();
        }
      });
    })

    return {
      mounted,
      activeTemplate,
      closeOverlay,
      modalData,
      directionGoogleLink,
      directionWazeLink,
      navigate,
      modalLastUpdate,
      modalCreateTime,
      getContrastActive,
      stopCloseHandler,
    };
  },
});
export default Modal;
</script>

<style lang="scss">
  @import "~sass-rem";
  .modal{
    position: relative;
    font-family: "Roboto", sans-serif;
    width: rem(650px);
    background-color: $main-bg-color;
    padding: rem(25px);
    padding-bottom: rem(40px);
    padding-top: rem(33px);
    // padding-right: rem(34px);
    transition: opacity ease-in-out 0.5s, margin-top ease-in-out 0.5s;
    margin-top: -200px;
    pointer-events: none;
    opacity: 0;
    color: $main-font-color;
    margin: 0 rem(6px);
    box-shadow: 0 4px 18px 0px rgb(0 0 0 / 20%);

    &__custom-templates {
      overflow-y: auto;
      overflow-x: hidden;
      padding-right: rem(2px);
      padding-bottom: 16px;

      @include width-from($mobile) {
        max-height: calc(90vh - 160px);
      }

      @include width-until($mobile) {
        max-height: calc(70vh - 160px);
      }
    }

    //custom modal classes
    &--event {
      .modal__title {
        color: $static_red_light;
      }
    }

    .dark-theme & {
      background-color: $dark-static;
      border: 2px solid $yellow-static;
    }

    &__template-content {
      width: 100%;
    }

    &__card{
      display: flex;
      // align-items: center;
      justify-content: space-evenly;
      margin-bottom: rem(14px);
    }
    &__icon{
      width: 25%;
      font-size: rem(66px);
      line-height: rem(66px);
      padding-right: rem(16px);

      &-content{
        width: 50px;
        height: 50px;
        background-color: currentColor;
        border-radius: rem(5px);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
    }
    &__content{
      width: 75%;
      font-size: rem(16px);
      line-height: rem(22px);
      letter-spacing: rem(0.7px);
      margin-top: rem(10px);
    }
    &__description{
      // max-height: rem(400px);
      text-align: justify;
      margin-bottom: rem(16px);
    }
    &__buttons{
      margin-top: rem(12px);
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: rem(10px);
      right: rem(16px);
      left: 0;
      padding: 0 16px;
    }
    
    &__close{
      position: absolute;
      top: rem(8px);
      right: rem(10px);
      border-radius: 50%;
      height: rem(24px);
      width: rem(24px);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        color: $main-font-color;
        font-weight: 600;
        font-size: rem(34px);
      }
    }
    &__footer {
      &-logo {
        position: absolute;
        left: rem(12px);
        bottom: rem(12px);
        display: flex;
        align-items: center;

        &-icon {
          margin-right: rem(5px);
        }

        &-image  {
          margin-right: rem(5px);
          max-width: rem(100px);
        }

        &-text {
          font-size: rem(9px);
          font-weight: 600;
        }
      }
    }

    &--show{
      margin-top: 0;
      pointer-events: all;
      opacity: 1;
    }
    &__button{
      display: flex;
      letter-spacing: rem(0.7px);
      text-transform: uppercase;
      font-weight: 500;
      padding: rem(5px);
      border-radius: rem(5px);
      cursor: pointer;
      margin-top: 15px;
      position: relative;
      overflow: hidden;

      &:after {
        content: "";
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: -100%;
        background-color: rgba(0, 0, 0, .1);
        transition: 0.3s ease-in;
      }

      &:hover {
        &:after {
          transform: translateX(0);
          transition: 0.3s ease-in;
          left: 0;
        }
      }

      svg{
        height: rem(19.5px);
        fill: $modal-parking_standard_icon;
        margin-right: rem(6px);
      }
    }
    &__title{
      // color: #285397;
      letter-spacing: rem(0.7px);
      font-size: rem(18.4px);
      font-weight: 700;
      line-height: rem(22px);
      text-transform: uppercase;

      @include width-until($mobile) {
        font-size: rem(14px);
      }
    }
    &__update-time{
      letter-spacing: rem(0.53px);
      font-size: rem(12px);
      line-height: rem(22px);
    }

    .text-data{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      &__label{
        font-size: rem(10px);
      }
      &__value{
        font-size: rem(12px);
      }
    }
    .current-weather{
      display: flex;
      flex-direction: column;
      align-items: center;
      &__icon-row{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      &__icon{
        display: none;
        margin-right: rem(50px);
        i{
          display: block;
          font-size: rem(120px);
          line-height: rem(120px);
        }
      }
      &__temperature{
        font-size: rem(36px);
        line-height: rem(36px);
      }
      &__description{
        margin-top: rem(35.5px);
        display: none;
      }
    }
    .icon-data{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      &__value{
        font-size: rem(12px);
      }
      &__icon{
        font-size: rem(25px);
        height: rem(25px);
        margin-bottom: rem(12px);
        i{
          display: block;
        }
      }
    }

    .parking-data {
      letter-spacing: rem(0.7px);
      font-size: rem(16px);
      line-height: rem(22px);
      &--has-data {
        .empty-data {
          display: none;
        }
      }

      &--empty-data {
        .empty-data {
          display: block;
          margin-top: 10px;
        }
      }
      &__table {
        margin-top: 10px;

        table {
          border: 1px solid #ddd;
          border-collapse: collapse;
          width: 100%;

          td, th {
            border: 1px solid #ddd;
            text-align: left;
          }

          th, td {
            padding: 10px;
          }

          thead, tfoot {
            background: #efefef;
          }
        }
      }
      &__icons{
        width: rem(200px);
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: rem(8px);
        margin-bottom: rem(20px);
        i{
          font-size: rem(24px);
        }
      }
      &__icon-data{
        flex-grow: 1;
        line-height: 1rem;
        padding-left: rem(18px);
      }
      &__button{
        display: flex;
        letter-spacing: rem(0.7px);
        text-transform: uppercase;
        font-weight: 500;
        svg{
          height: rem(19.5px);
          fill: #285397;
          margin-right: rem(6px);
        }
      }
      &__header {
        font-weight: 700;
      }
      &__description {
      }
    }
  }
</style>
